var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 11L16.775 6.275C17.075 5.975 17.075 5.525 16.775 5.225C16.475 4.925 16.025 4.925 15.725 5.225L11 9.95L6.275 5.225C5.975 4.925 5.525 4.925 5.225 5.225C4.925 5.525 4.925 5.975 5.225 6.275L9.95 11L5.225 15.725C5.075 15.875 5 16.025 5 16.25C5 16.7 5.3 17 5.75 17C5.975 17 6.125 16.925 6.275 16.775L11 12.05L15.725 16.775C15.875 16.925 16.025 17 16.25 17C16.475 17 16.625 16.925 16.775 16.775C17.075 16.475 17.075 16.025 16.775 15.725L12.05 11Z",
    fill: "#212529",
    stroke: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.abe870d8e36d303ba743b45df9be8967.svg";
export { ForwardRef as ReactComponent };